import React, { FC } from 'react';
import { iLTO } from "@models/LTO";
import LTOItem from "@pages/_shared/LTOItem/LTOItem";
import LazyGrid from "@components/new/Grid/LazyGrid/LazyGrid";

const FoodLaunchesGrid: FC<{
    data: iLTO[];
    isLimitedAccess?: boolean;
}> = ({
    data,
    isLimitedAccess,
}) => {
    return (
        <div>
            <LazyGrid
                itemWidth={300}
                offset={300}
                isLimitedAccess={isLimitedAccess}
            >
                {data.map((item, index) => ({
                    key: item.id,
                    value: (
                        <LTOItem
                            style={{
                                wrapper: {
                                    boxShadow: undefined,
                                    border: '1px solid #EAEAEA',
                                }}}
                            data={item}
                            location="food profile"
                            testId={`blockFoodLaunchesGridItem-${index}`}
                            isNewDesign={true}
                        />
                    ),
                }))}
            </LazyGrid>
        </div>
    );
}

export default FoodLaunchesGrid;